<template>
  <div style="padding: 30px;">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row>
        <el-col v-if="step == 2" :span="24">
          <el-form-item label="本次付款方式">
            <el-input :placeholder="payTypeTip" disabled />
          </el-form-item>
        </el-col>
        <el-col v-if="step == 1" :span="24">
          <el-form-item label="运费金额">
            <el-input v-model="order.taxFee" disabled>
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="step == 1" :span="24">
          <el-form-item label="已付费金额">
            <el-input v-model="order.allotTaxAmount" disabled>
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="预付金额" prop="prepaidAmount">
            <el-input
              v-model="form.prepaidAmount"
              :disabled="step != 1"
              @input="
                value =>
                  formFormatter.isFloor2(value, oldValue, form, 'prepaidAmount')
              "
            />
          </el-form-item>
        </el-col>
        <template v-if="needSmsCode && step == 2">
          <el-col :span="20">
            <el-form-item
              label="获取验证码"
              prop="verificationCode"
              :rules="{
                required: true,
                message: `请输入验证码`,
                trigger: 'change'
              }"
            >
              <el-input
                v-model="form.verificationCode"
                maxlength="20"
                placeholder="请输入验证码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <verificationCode
              ref="ishowRef"
              :api-fun="apiFun"
              :query-obj="queryObj"
              @getSms="getSms"
            />
          </el-col>
        </template>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="step == 1" type="primary" @click="getPrepaidClick()">
        支付
      </el-button>
      <el-button
        v-if="step == 2"
        :disabled="disabled"
        type="primary"
        @click="payclick()"
      >
        确认打款
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import {
  shipperPrepaidConfirm,
  shipperPrePayment,
  getVerificationCodeShipperPrepaid,
  sendVerificationCode
} from "@/api/transport";
import { isFixed2 } from "@/utils/validate4Form";
import verificationCode from "@/components/verificationCode";
export default {
  name: "PayadvanceShipmentMoney",
  components: {
    verificationCode
  },
  data() {
    return {
      cashdisabled: false,
      disabled: true,
      show: true,
      count: "",
      order: {
        deliveryFeeDeserved: "",
        allotTaxAmount: ""
      },
      emptyForm: {},
      form: {
        code: "",
        prepaidAmount: 0,
        operationalCode: "",
        verificationCode: ""
      },
      rules: {
        code: [
          { required: true, message: "运单编号不能为空", trigger: "blur" }
        ],
        prepaidAmount: [
          { required: true, message: "请输入预付金额", trigger: "blur" },
          { validator: isFixed2, trigger: "blur" }
        ]
      },
      payTypeTip: "",
      step: 1,
      method: "",
      paymentType: "",
      needSmsCode: false,
      apiFun: "",
      // 托运人手机号
      shipperPhone: ""
    };
  },
  mounted() {
    // 判断验证码是否显示
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
    const partyType = this.$store.getters.party.partyType;
    let isShipment = partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY";
    if (isShipment) {
      this.source = "shipment";
    }
  },
  methods: {
    setFee(row) {
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      this.order = row;
      this.paymentType = row.paymentType;
      this.form.code = row.code;
      this.form.prepaidAmount = ""; //(row.deliveryFeeDeserved - row.allotTaxAmount).toFixed(2)
      this.step = 1;
      this.disabled = true;
      this.shipperPhone = row.ordCreatedByPhone;
    },
    close() {
      this.cashdisabled = false;
      this.count = 0;
      this.disabled = true;
    },
    getSms(data, arg) {
      this.disabled = false;
      this.form.body = data.body;
      this.form.orderDetailCode = data.orderDetailCode;
      this.form.orderNo = data.orderNo;
      this.form.outTradeNo = data.outTradeNo;
      this.form.payeeId = data.payeeId;
      this.form.payeeType = data.payeeType;
      this.form.payerMerchantId = data.payerMerchantId;
      this.form.source = data.source;
      this.form.totalAmount = data.totalAmount;
    },
    // verifyPayee(params, backFun) {
    //   request({
    //     url: `/ntocc-tms-api/payAdvance/verifyPayee`,
    //     method: "get",
    //     params: params
    //   }).then(response => {
    //     if (response.data) {
    //       backFun();
    //     } else {
    //       this.$confirm(
    //         "预付将使本账户汇款超额，是否继续预付操作？"
    //       ).then(_ => {
    //         backFun();
    //       });
    //     }
    //   });
    // },
    // 托运人预付第一步，判断预付，获取支付信息
    getPrepaidClick() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading();
          let data = {
            code: this.form.code,
            prepaidAmount: this.form.prepaidAmount
          };
          if (this.paymentType == "arpa") {
            let response = await shipperPrePayment(data);
            this.$message.success(response.msg);
            this.$emit("closeWindows");
            return;
          }
          request({
            url: `/ntocc-tms-api/payAdvance/shipperPrepaid`,
            method: "post",
            params: data
          }).then(response => {
            if (response.status == 0) {
              this.form.operationalCode = response.method;
              this.needSmsCode = response.data.needSmsCode == "yes";
              if (this.form.operationalCode != "6003") {
                this.disabled = false;
              }
              // 虚拟或网商 -需要验证码 使用之前的获取验证码的接口
              if (this.form.operationalCode == "6003") {
                this.apiFun = getVerificationCodeShipperPrepaid;
                this.queryObj = {
                  orderDetailCode: this.form.code,
                  totalAmount: this.form.prepaidAmount,
                  orderNo: this.form.orderNo
                };
              }
              if (this.form.operationalCode == "6002") {
                if (response.data) {
                  let form = Object.assign(this.form, this.form, response.data);
                  this.form = form;
                }
              }
              // 6004 是中信的 使用中心的获取验证码的接口 phone不是必传
              if (this.form.operationalCode == "6004") {
                this.apiFun = sendVerificationCode;
                this.queryObj = {
                  phone: this.shipperPhone,
                  code: this.form.code,
                  amount: this.form.prepaidAmount,
                  source: "shipment"
                };
              }
              this.step = 2;
              this.payTypeTip = response.msg;
              rLoading.close();
            }
          });
        }
      });
    },
    //托运人预付第二步 确认预付
    payclick() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading();
          let data = this.form;
          let response = await shipperPrepaidConfirm(data);
          if (response.status == 0) {
            this.show = true;
            rLoading.close();
            this.step = 1;
            this.$emit("closeWindows");
            this.$message.success(response.msg);
            this.disabled = true;
          }
        }
      });
    },
    //获取验证码
    getCode() {
      let data = {
        orderDetailCode: this.form.code,
        totalAmount: this.form.prepaidAmount
      };
      const $this = this;
      if (data.totalAmount == "") {
        this.$message({
          message: "预付金额不能为空",
          type: "warning"
        });
      } else {
        const rLoading = $this.openLoading();
        request({
          url: `/ntocc-tms-api/mybankBalancePay/getVerificationCodeShipperPrepaid`,
          method: "put",
          params: data
        }).then(response => {
          rLoading.close();
          $this.$message({
            message: response.msg,
            type: "success"
          });
          let form = Object.assign($this.form, $this.form, response.data);
          $this.form = form;
          if (response.status == 0) {
            const TIME_COUNT = 60;
            if (!$this.timer) {
              $this.count = TIME_COUNT;
              $this.show = false;
              $this.timer = setInterval(() => {
                if ($this.count > 0 && $this.count <= TIME_COUNT) {
                  $this.count--;
                } else {
                  $this.show = true;
                  clearInterval($this.timer);
                  $this.timer = null;
                }
              }, 1000);
            }
          }
        });
      }
    },
    isFloor(e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  float: right;
}
.count,
.smscode {
  height: 40px;
  line-height: 40px;
  display: block;
  padding-left: 5px;
}
</style>
